import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { compareAsc, format } from "date-fns";
import moment from "moment";
function UpdateUserProfileCom() {
  let SERVER_URL = process.env.REACT_APP_API_URL;
  let BASE_URL = process.env.REACT_APP_APP_URL;
  let token = JSON.parse(localStorage.getItem("key"));
  const dispatch = useDispatch();
  const get_oermission_data = useSelector((state) => state);
  const user_info = get_oermission_data.login_Permission.user_data;
  const user_img = user_info?.img ? user_info?.img : user_info?.gender == 1 ? 'm_user.png' : 'f_user.png';

  const RMGF = user_info?.RMGF ? user_info?.RMGF : '';
  const RMGM = user_info?.RMGM ? user_info?.RMGM : '';
  const RMGL = user_info?.RMGL ? user_info?.RMGL : '';
  const userFname = user_info?.fname ? user_info?.fname : '';
  const userMname = user_info?.mname ? user_info?.mname : '';
  const userLname = user_info?.lname ? user_info?.lname : '';
  const nationality_type = user_info?.nationality_type ? user_info?.nationality_type : '';
  const [userId, setUserId] = useState(localStorage.getItem('userId'))
  const [dateofjoining, setDateofjoining] = useState("");

  const [emgname, setEmgname] = useState('');
  const [emgrelation, setEmgrelation] = useState('');
  const [emgcontact, setEmgcontact] = useState('');

  const [pannumber, setPannumber] = useState('');
  const [adharnumber, setAdharnumber] = useState('');
  const [nationality, setNationality] = useState('');
  const [marriagestatus, setMarriagestatus] = useState('');
  const [contact, setContact] = useState('')
  const [err, serErr] = useState('');
  const [msg, serMsg] = useState('');

  useEffect(() => {
    setNationality(user_info?.nationality_type ? user_info?.nationality_type : '')
    setPannumber(user_info?.pan_no ? user_info?.pan_no : '')
    setAdharnumber(user_info?.uid_no ? user_info?.uid_no : '')
    setMarriagestatus(user_info?.marrige_status ? user_info?.marrige_status : '')
    setEmgname(user_info?.emergencycontactperson ? user_info?.emergencycontactperson : '')
    setEmgrelation(user_info?.personrelation ? user_info?.personrelation : '')
    setEmgcontact(user_info?.emergencyphonenumber ? user_info?.emergencyphonenumber : '')
    setContact(user_info?.contact ? user_info?.contact : '')
  }, [user_info?.nationality_type, user_info?.pan_no, user_info?.uid_no, user_info?.marrige_status, user_info?.contact])

  const UpdateUserInfo = () => {
    const response = fetch(SERVER_URL + `api/employee/userupdate`, {
      method: 'post',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'authorization': `bearer ${token.value}`
      },
      body: JSON.stringify({
        id: userId, emgname: emgname, emgcontact: emgcontact, emgrelation: emgrelation, pannumber: pannumber, adharnumber: adharnumber, nationality: nationality, marriagestatus: marriagestatus, contact: contact
      }),


    }).then(res => res.json())
      .then(data => {
        if (data.status == true) {
          serMsg(data.msg)
          serErr('green')
          setTimeout(() => {
            serMsg('')
            serErr('')
          }, 1000);
        } else {
          serMsg(data.msg)
          serErr('red')
        }
      })
  }

  return (
    <div className="container-fluid">
      <div className="dash_ttl">Profile</div>
      <div className="crumbs">
        <ul id="breadcrumbs" className="breadcrumb">
          <li>
            <a href="#">Dashboard </a>
          </li>
          <li className="current">
            <span>/</span>Profile
          </li>
        </ul>
      </div>
      <div className="profile_detail_wrp">
        <div className="row">
          <div className="col-md-3">
            <div className="profile_detail">
              <div className="profile_img_wrp">
                <div className="pro_img profile_upload_wrp">
                  <img src={`${SERVER_URL + "userimages/" + user_img}`} alt="" />
                  <div className="buttonwrap">
                    <label className="button_upload" htmlFor="upload">
                      <i className="fa fa-camera"></i>
                    </label>
                    {/* <input id="upload" type="file" onChange={HandleProfileImg} /> */}
                  </div>
                </div>
                <div className="pro_detail">
                  <div className="pro_detail">
                    <div className="pro_title"> {userFname + ' ' + userMname + ' ' + userLname}</div>
                    <div className="pro_sub_head"> {user_info?.role_name ? user_info.role_name : ""}</div>
                    <div className="pro_sub_head"><i className="icon icon-apartment"></i>{user_info?.dept_name ? user_info.dept_name : ""}</div>
                  </div>
                </div>
              </div>
              <div className="pro_wrp">
                <div className="pro_blk">
                  <div className="pro_heading">Phone Number</div>
                  <div className="pro_sub_head">
                    <i className="icon icon-telephone2 mr08"></i>
                    {user_info?.contact ? user_info?.contact : ""}
                  </div>
                </div>
                <div className="pro_blk">
                  <div className="pro_heading">Email</div>
                  <div className="pro_sub_head">
                    <i className="icon icon-envelope mr08"></i>
                    {user_info?.email ? user_info?.email : ""}
                  </div>
                </div>
                <div className="pro_blk">
                  <div className="pro_heading">Date of Birth</div>
                  <div className="pro_sub_head">
                    <i className="icon icon-cake mr08"></i>
                    {user_info?.birth ? moment(user_info?.birth).format("DD, MMM YYYY") : ""}
                  </div>
                </div>
                <div className="pro_blk">
                  <div className="pro_heading">Date of Joining</div>
                  <div className="pro_sub_head">
                    <i className="icon icon-calendar-full mr08"></i>
                    {user_info?.dateOfJoining ? moment(user_info?.dateOfJoining).format("DD, MMM YYYY") : ""}
                  </div>
                </div>
                <div className="pro_blk">
                  <div className="pro_heading">Reporting Manager</div>
                  <div className="pro_sub_head">{RMGF ? RMGF : ''} {RMGM ? RMGM : ''} {RMGL ? RMGL : ''}</div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-9 relative">
            <div className="tab-content" id="profiletabContent">
              <div
                className="tab-pane fade active show"
                id="personal"
                role="tabpanel"
                aria-labelledby="personal-tab"
              >
                <div className="row mb30">
                  <div className="col-md-4">
                    <div className="form-blk mb20">
                      <div className="form-label">AADHAAR CARD NUMBER </div>
                      <div className="form-input fw-500">
                        <input type="text" onChange={e => { setAdharnumber(e.target.value) }} value={adharnumber} className='form-control' />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-blk mb20">
                      <div className="form-label">PAN CARD NUMBER</div>
                      <div className="form-input fw-500">
                        <input type="text" onChange={e => { setPannumber(e.target.value) }} value={pannumber} className='form-control' />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-blk mb20">
                      <div className="form-label">NATIONALITY</div>
                      <div className="form-input fw-500">
                        <input type="text" onChange={e => { setNationality(e.target.value) }} value={nationality} className='form-control' />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-blk mb20">
                      <div className="form-label">MARITAL STATUS </div>
                      <div className="form-input fw-500">
                        <select value={marriagestatus} onChange={e => { setMarriagestatus(e.target.value) }} className='form-control'>
                          <option value=''> Select </option>
                          <option value='1'> married </option>
                          <option value='2'> unmarried </option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-blk mb20">
                      <div className="form-label">CONTACT NUMBER </div>
                      <div className="form-input fw-500">
                        <input type='text' value={contact} onChange={e => { setContact(e.target.value) }} className='form-control' />

                      </div>
                    </div>
                  </div>
                  <div className="tab_sub_ttl">Emergency Contact</div>
                  <div className="col-md-4">
                    <div className="form-blk mb20">
                      <div className="form-label">Name</div>
                      <div className="form-input fw-500">
                        <input onChange={e => { setEmgname(e.target.value) }} type="text" name="" value={emgname} className='form-control' />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-blk mb20">
                      <div className="form-label">RELATIONSHIP</div>
                      <div className="form-input fw-500">
                        <input onChange={e => { setEmgrelation(e.target.value) }} type="text" name="" value={emgrelation} className='form-control' />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-blk mb20">
                      <div className="form-label">Mobile</div>
                      <div className="form-input fw-500">
                        <input onChange={e => { setEmgcontact(e.target.value) }} type="text" name="" value={emgcontact} className='form-control' />
                      </div>
                    </div>
                  </div>
                  <div className=" text-end">
                    <div style={{ color: `${err}` }}>{msg}</div>
                    <button onClick={UpdateUserInfo} className="btn_5">Update</button>
                  </div>
                </div>
              </div>










            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default UpdateUserProfileCom
